import { useContext } from 'react';
import { PropsContext } from './PropsContext';

export const usePropsContext = () => {
  return useContext(PropsContext);
};
